import { getOutlineStyle } from './input';
const baseStyle = {
    width: '100%',
    outline: 0,
    lineHeight: 1,
    transition: 'all 250ms',
};
const variants = {
    outline: (props) => {
        return {
            ...getOutlineStyle(props).field,
            paddingX: 3,
            paddingY: 2,
            display: 'block',
            lineHeight: 'inherit',
        };
    },
};
const defaultProps = {
    variant: 'outline',
};
export default {
    baseStyle,
    variants,
    defaultProps,
};
//# sourceMappingURL=textarea.js.map